import React from "react";

const LocateVehiclesIcon = ({ width = 16, height = 16, color = "black", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.203 3.12914C14.6053 2.27997 13.7203 1.39508 12.8712 1.79732L1.88974 6.99904C1.04115 7.40098 1.16435 8.64518 2.07529 8.87291L6.11696 9.88338L7.12739 13.925C7.35512 14.836 8.59932 14.9592 9.00125 14.1106L14.203 3.12914Z"
      fill={color}
    />
  </svg>
);

export default LocateVehiclesIcon;
